"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    recordsTable: {
        path: "/records/:category",
    },
    createSubmission: {
        path: "/submissions/create/:submissionTypeId/:objectId?/",
    },
    viewSubmission: {
        path: "/submissions/:submissionId",
    },
    editSubmission: {
        path: "/submissions/:submissionId/edit",
    },
    submissionSummary: {
        path: "/submissions/:submissionId/summary",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VibWlzc2lvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3N1Ym1pc3Npb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsWUFBWSxFQUFFO1FBQ1osSUFBSSxFQUFFLG9CQUFvQjtLQUMzQjtJQUNELGdCQUFnQixFQUFFO1FBQ2hCLElBQUksRUFBRSxtREFBbUQ7S0FDMUQ7SUFDRCxjQUFjLEVBQUU7UUFDZCxJQUFJLEVBQUUsNEJBQTRCO0tBQ25DO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsSUFBSSxFQUFFLGlDQUFpQztLQUN4QztJQUNELGlCQUFpQixFQUFFO1FBQ2pCLElBQUksRUFBRSxvQ0FBb0M7S0FDM0M7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIHJlY29yZHNUYWJsZToge1xuICAgIHBhdGg6IFwiL3JlY29yZHMvOmNhdGVnb3J5XCIsXG4gIH0sXG4gIGNyZWF0ZVN1Ym1pc3Npb246IHtcbiAgICBwYXRoOiBcIi9zdWJtaXNzaW9ucy9jcmVhdGUvOnN1Ym1pc3Npb25UeXBlSWQvOm9iamVjdElkPy9cIixcbiAgfSxcbiAgdmlld1N1Ym1pc3Npb246IHtcbiAgICBwYXRoOiBcIi9zdWJtaXNzaW9ucy86c3VibWlzc2lvbklkXCIsXG4gIH0sXG4gIGVkaXRTdWJtaXNzaW9uOiB7XG4gICAgcGF0aDogXCIvc3VibWlzc2lvbnMvOnN1Ym1pc3Npb25JZC9lZGl0XCIsXG4gIH0sXG4gIHN1Ym1pc3Npb25TdW1tYXJ5OiB7XG4gICAgcGF0aDogXCIvc3VibWlzc2lvbnMvOnN1Ym1pc3Npb25JZC9zdW1tYXJ5XCIsXG4gIH0sXG59KTtcbiJdfQ==